module.exports = __webpack_public_path__ + "static/media/UNDER.0d646e57.png";